import { Currency } from '@/types/currency';
import { addCurrency } from '@/utils/numbers';

interface Props {
  currency: keyof typeof Currency;
  decimals?: number;
  children?: string | number;
  preffix?: string;
  suffix?: string;
}

const Price = ({
  currency,
  children,
  decimals = 2,
  preffix = '',
  suffix = '',
}: Props) => {
  return (
    <span className="notranslate">
      {preffix}
      {addCurrency(children, currency, decimals)}
      {suffix}
    </span>
  );
};

export default Price;
